import Vue from 'vue'

const mutations = {
	setProjectsStatisticsData (state, data) {
		Vue.set(state, 'projectsStatisticsData', data)
	}
}

export default mutations
